import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/select";
import { ReactComponent as RightArrow } from "assets/morning/icon/rightArrow.svg";
import { useNavigate } from "react-router-dom";

export default function SelectSubmenu({ menuItems, activeIndex }: { menuItems: any[]; activeIndex: number }) {
    const navigate = useNavigate();
    const currentMenu = menuItems[activeIndex].label;
    return (
        <Select
            // open
            value={currentMenu}
            onValueChange={value => {
                const index = menuItems.findIndex(item => item.label === value);
                const path = menuItems[index].path instanceof Array ? menuItems[index].path[0] : menuItems[index].path;
                navigate(path);
            }}
        >
            <SelectTrigger className="w-full text-white border-none h-[50px] justify-center !px-[0] relative">
                <SelectValue placeholder="" className="text-white" />
                <RightArrow className="absolute right-[40px] top-1/2 -translate-y-1/2 rotate-[90deg]" width={22} />
            </SelectTrigger>
            <SelectContent className="bg-[rgba(21,34,65,0.85)] text-white border-none  ml-[-10px]">
                {menuItems.map((item, index) => (
                    <SelectItem key={index} value={item.label} className="data-[state=checked]:bg-[rgb(21,34,65)]">
                        {item.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
